import { useEffect, useState } from 'react';
import { STEP_STATUS } from '../components/WhatsApp/constants';

const useWhatsAppOnboarding = () => {
  const [step, setStep] = useState(1);
  const [eligibilityStep, setEligibilityStep] = useState(1);
  const [connectionOption, setConnectionOption] = useState('');
  const [phoneValidationOption, setPhoneValidationOption] = useState('');
  const [subStep, setSubStep] = useState('');
  const [existingStep, setExistingStep] = useState(1);
  const [stepStatus, setStepStatus] = useState({
    step1: STEP_STATUS.ACTIVE,
    step2: '',
    step3: '',
    step4: '',
  });
  const [eligibilityStatus, setEligibilityStatus] = useState({
    step1: STEP_STATUS.ACTIVE,
    step2: STEP_STATUS.INACTIVE,
  });

  useEffect(() => {
    updateStepStatus();
    updateEligibilityStatus();
  }, [step, eligibilityStep]);

  const updateStepStatus = () => {
    switch (step) {
      case 1:
        setStepStatus({
          step1: STEP_STATUS.ACTIVE,
          step2: '',
          step3: '',
          step4: '',
        });
        break;
      case 2:
        setStepStatus({
          step1: STEP_STATUS.PROCESSED,
          step2: STEP_STATUS.ACTIVE,
          step3: '',
          step4: '',
        });
        break;
      case 3:
        setStepStatus({
          step1: STEP_STATUS.PROCESSED,
          step2: STEP_STATUS.PROCESSED,
          step3: STEP_STATUS.ACTIVE,
          step4: '',
        });
        break;
      case 4:
        setStepStatus({
          step1: STEP_STATUS.PROCESSED,
          step2: STEP_STATUS.PROCESSED,
          step3: STEP_STATUS.PROCESSED,
          step4: STEP_STATUS.ACTIVE,
        });
        break;
      default:
        setStepStatus({
          step1: STEP_STATUS.ACTIVE,
          step2: '',
          step3: '',
          step4: '',
        });
        break;
    }
  };

  const updateEligibilityStatus = () => {
    if (eligibilityStep === 1) {
      setEligibilityStatus({
        step1: STEP_STATUS.ACTIVE,
        step2: STEP_STATUS.INACTIVE,
      });
    } else {
      setEligibilityStatus({
        step1: STEP_STATUS.PROCESSED,
        step2: STEP_STATUS.ACTIVE,
      });
    }
  };

  const handleOptionChange = (event) => {
    setConnectionOption(event.target.value);
  };

  const handlePhoneValidationChange = (event) => {
    setPhoneValidationOption(event.target.value);
  };

  const handleGetStarted = () => {
    if (step === 1 && !connectionOption) {
      setConnectionOption('new');
    }
    setStep(step + 1);
  };

  const handleEligibilityNext = () => {
    if (eligibilityStep === 1 && !phoneValidationOption) {
      setPhoneValidationOption('none');
      setSubStep('none');
      return;
    }
    if (phoneValidationOption === 'existing') {
      setSubStep('existing');
      return;
    }
    if (phoneValidationOption === 'none') {
      setSubStep('none');
      return;
    }
    setEligibilityStep(eligibilityStep + 1);
  };

  const handleExistingNext = () => {
    if (existingStep === 2) return;
    setExistingStep(existingStep + 1);
  };

  const handleBackStep = () => {
    switch (step) {
      case 1:
        return;
      case 2:
        if (connectionOption === 'new') {
          if (eligibilityStep === 1) {
            if (subStep === '' && phoneValidationOption === '') {
              setStep(step - 1);
              return;
            }
            setSubStep('');
            setPhoneValidationOption('');
            return;
          }
          setEligibilityStep(eligibilityStep - 1);
        } else {
          setStep(step - 1);
        }
        return;
      case 3:
        setStep(step - 1);
        return;
      default:
        return;
    }
  };

  return {
    step,
    setStep,
    eligibilityStep,
    setEligibilityStep,
    connectionOption,
    phoneValidationOption,
    subStep,
    existingStep,
    stepStatus,
    eligibilityStatus,
    handleOptionChange,
    handlePhoneValidationChange,
    handleGetStarted,
    handleEligibilityNext,
    handleExistingNext,
    handleBackStep,
  };
};

export default useWhatsAppOnboarding;
